
// NOT SURE THIS NEEDED ANYMORE IN ANGULAR 11 - DK
import * as angular from "angular";

export class FileSelectedDirective implements angular.IDirective {

    restrict = "A";
    scope = false;

    link: ($scope: angular.IScope, $element: ng.IAugmentedJQuery, $attrs: ng.IAttributes, ngModel) => void;

    constructor() {

        FileSelectedDirective.prototype.link = ($scope: angular.IScope, $element: angular.IAugmentedJQuery, $attrs: ng.IAttributes) => {

            $element.bind("change", (event) => {
                var file = ((event.srcElement || event.target) as any).files[0];
                $scope.$eval($attrs.fileSelected, { file: file });
            });

            $scope.$on("$destroy", () => {
                $element.unbind("change");
            });
        }
    }

    static factory(): angular.IDirectiveFactory {
        const directive = () => new FileSelectedDirective();

        directive.$inject = [];

        return directive;
    }
}
